<template>
    <div class="customer-flows-repeater" style="width: 100%">
        <div class="customer-flows-repeater__items">
            <transition-group name="fade-down">
                <div
                    v-for="(setting, index) in buildSettings"
                    :key="index"
                    class="customer-flow-form"
                    style="position: relative; border-bottom: 1px solid #eee"
                >
                    <div
                        v-if="buildSettings.length > 1"
                        class="customer-flow-form__detele"
                        style="position: absolute; right: 0; top: 0; z-index: 1000"
                    >
                        <button
                            type="button"
                            class="button users-repeater-item__delete"
                            @click.prevent="onDelete(setting)"
                        >
                            <IconCross />
                        </button>
                    </div>
                    <Grid gap-y="10">
                        <Column :span="6">
                            <FormField
                                name="build_types"
                                :label="schema.build_types.label"
                                :required="schema.build_types.required"
                            >
                                <MultiSelect
                                    v-model="buildSettings[index].build_types"
                                    emit-prop="value"
                                    view-label="display_name"
                                    :form-value-text="({ display_name }) => display_name"
                                    :options="schema.build_types.choices"
                                    width="100%"
                                />
                            </FormField>
                        </Column>
                        <Column :span="6">
                            <FormField
                                name="providers"
                                :label="schema.provider.label"
                                :required="schema.provider.required"
                            >
                                <CustomSelect
                                    v-model="buildSettings[index].provider"
                                    emit-prop="value"
                                    view-label="display_name"
                                    :form-value-text="({ display_name }) => display_name"
                                    :options="schema.provider.choices"
                                    width="100%"
                                />
                            </FormField>
                        </Column>
                    </Grid>
                    <Grid>
                        <Column>
                            <FormField name="without_author">
                                <Checkbox v-model="buildSettings[index].without_author">
                                    {{ schema.without_author.label }}
                                </Checkbox>
                            </FormField>
                        </Column>
                        <Column>
                            <FormField name="without_author">
                                <Checkbox v-model="buildSettings[index].without_title">
                                    {{ schema.without_title.label }}
                                </Checkbox>
                            </FormField>
                        </Column>
                        <Column>
                            <FormField name="without_author">
                                <Checkbox v-model="buildSettings[index].without_preview">
                                    {{ schema.without_preview.label }}
                                </Checkbox>
                            </FormField>
                        </Column>
                    </Grid>
                </div>
            </transition-group>
        </div>
        <button
            :class="['button', 'button--fullwidth']"
            style="margin: 0 auto"
            type="button"
            @click="addBuildSetting"
        >
            + Add another build setting
        </button>
    </div>
</template>

<script>
import { Checkbox, FormField, CustomSelect, MultiSelect } from '@speechki-frontend/shared/ui/forms';
import { Grid, Column } from '@speechki-frontend/shared/ui/Grid';
import { IconCross } from '@speechki-frontend/shared/ui/icons';

const initialBuildSetting = {
    provider: '',
    build_types: [],
    without_title: false,
    without_author: false,
};

export default {
    name: 'CustomerBuildSettingsRepeater',
    components: {
        Checkbox,
        FormField,
        CustomSelect,
        Grid,
        Column,
        IconCross,
        MultiSelect,
    },
    props: {
        schema: {
            type: Object,
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            buildSettings: [],
        };
    },

    watch: {
        buildSettings: {
            deep: true,
            handler() {
                this.update(this.buildSettings);
            },
        },
    },

    mounted() {
        this.addBuildSetting();
    },

    methods: {
        addBuildSetting() {
            this.buildSettings.push({ ...initialBuildSetting });
        },
        update(event) {
            this.$emit('update:modelValue', event);
        },
        onDelete(event) {
            this.buildSettings.splice(this.buildSettings.indexOf(event), 1);
        },
    },
};
</script>
